import React from "react";

import PanelSection from "ui/PanelSection";

import { useQuerySearchResultsQuery } from "./gql/Query.generated";

import ExplainTable from "features/Explain/ExplainTable";
import Loading from "ui/Loading";

const Results = ({
  databaseId,
  searchKey,
  searchValue,
  startTs,
  endTs,
}: {
  databaseId: string;
  searchKey: string;
  searchValue: string;
  startTs: number;
  endTs: number;
}) => {
  const { loading, error, data } = useQuerySearchResultsQuery({
    variables: {
      databaseId,
      searchKey,
      searchValue,
      startTs,
      endTs,
    },
  });
  if (loading || error) {
    return <Loading error={!!error} />;
  }

  if (data.getQueryTagsets.length == 0) {
    return <PanelSection>No results found</PanelSection>;
  }

  const explains = data.getQueryTagsets
    .filter((queryTagset) => {
      return queryTagset.querySample && queryTagset.querySample.explain;
    })
    .map((queryTagset) => {
      return {
        ...queryTagset.querySample.explain,
        querySample: {
          occurredAt: queryTagset.querySample.occurredAt,
          runtimeMs: queryTagset.querySample.runtimeMs,
          queryText: queryTagset.querySample.queryText,
        },
        query: { id: queryTagset.query.id },
      };
    });

  return (
    <ExplainTable
      explains={explains}
      databaseId={databaseId}
      blockSize={parseInt(data.blockSize.value, 10)}
    />
  );
};

export default Results;
